<template>
    <div>
        <section class="container mt-3 py-3">
            <h4>Progress Bar</h4>
            <div class="mb-3">
                <px-progress-bar :barHeight="25" :barPorcentaje="50"></px-progress-bar>
            </div>

            <p class="text-dark my-0">Codigo para la implementación de modal de confirmación.</p>
            <!-- CODIGO HTML -->
            <pre><textarea style="height:40px;" readonly>
            <px-progress-bar :barHeight="25" :barPorcentaje="50"></px-progress-bar></textarea></pre>

            <p class="text-dark my-0">Codigo para la implementación de modal de confirmación</p>
            <!-- CODIGO VUE JS -->
            <pre><textarea style="height:200px;" readonly>
            <script>
            import PxProgressBar from '@/components/PxProgressBar.vue'
                
            export default {
                components: {
                    PxProgressBar
                }
            }
            </script></textarea></pre>

            <!-- Propiedades -->
            <div class="my-2 ms-3 my-4">
                <div class="mb-3">
                    <h5>Atributos <u>obligatorios</u> de progress bar</h5>
                    <code>:barHeight</code> Alto de la barra de proceso en px (pixeles) <br>
                    <code>:barPorcentaje</code> Porcentaje que se representara en la barra <br>
                </div>
            </div>
            <!-- CONTENIDO A DEFINIR OJOOOO 👁️ -->
            <h4>Background</h4>
            <px-progress-bar :barHeight="25" :barPorcentaje="10" class="mb-2"></px-progress-bar>
            <px-progress-bar :barHeight="25" :barPorcentaje="48" class="mb-2"></px-progress-bar>
            <px-progress-bar :barHeight="25" :barPorcentaje="100" class="mb-2"></px-progress-bar>


        </section>
    </div>
</template>
<script>
import PxProgressBar from './../PxProgressBar.vue'
export default {
    created(){
        window.scrollTo(0, 0);
    },
    components:{
        PxProgressBar
    }
}
</script>